export default __webpack_public_path__ + "static/media/portfolio-187.de42889c.jpg";